module.exports = __webpack_public_path__ + "static/media/visa.9bf7645c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/visa.svg
// module id = 891
// module chunks = 7